import { Order } from 'mdello-client-ts/dist/src/interfaces/providers/ecommerce/order.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const getOrdersPaginated = async (params: {
  itemId?: string;
  page: string;
  pageSize: string;
  projectId: string;
  search: string;
  sortBy: string;
  sortOrder: string;
}): Promise<Order[] | undefined> => {
  const { projectId, page, pageSize, sortBy, sortOrder, search, itemId } = params;
  const response = await apiM7.get<Order[]>(
    `${API_URL_M7}/api_admin/v1/project/${projectId}/ecommerce/order/search?limit=${pageSize}&page=${page}&search=${search}&sortBy=${sortBy}&sortOrder=${sortOrder}${
      itemId === '' || itemId === 'All' ? '' : `&itemId=${itemId}`
    }`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};
